/**
 * Glossary search functionality
 * Handles real-time filtering of glossary terms based on user input
 */
document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('glossarySearch');
    const glossaryItems = document.querySelectorAll('.glossary-item');

    if (!searchInput || !glossaryItems.length) return;

    searchInput.addEventListener('input', function() {
        const searchTerm = this.value.toLowerCase();

        glossaryItems.forEach(item => {
            const title = item.querySelector('h3').textContent.toLowerCase();
            const description = item.querySelector('p').textContent.toLowerCase();
            
            if (title.includes(searchTerm) || description.includes(searchTerm)) {
                item.classList.remove('hidden');
            } else {
                item.classList.add('hidden');
            }
        });
    });
}); 